var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5041_11410)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.35638 7.54465L8.2367 8.784C8.21237 8.81092 8.18291 8.83239 8.15019 8.84706C8.11746 8.86173 8.08216 8.86929 8.04649 8.86927H2.73868C2.71336 8.86927 2.68858 8.86163 2.6674 8.8473C2.64622 8.83296 2.62956 8.81256 2.61947 8.78858C2.60937 8.76461 2.60628 8.73812 2.61058 8.71235C2.61487 8.68659 2.62637 8.66269 2.64364 8.64358L3.76416 7.40422C3.78844 7.37737 3.81779 7.35595 3.85041 7.34129C3.88303 7.32662 3.91822 7.31902 3.95381 7.31896H9.26132C9.28664 7.31896 9.31142 7.3266 9.33261 7.34093C9.35376 7.35526 9.37042 7.37567 9.38056 7.39964C9.39063 7.42362 9.39372 7.45011 9.38942 7.47587C9.38513 7.50163 9.37364 7.52554 9.35638 7.54465ZM8.2367 5.04894C8.21237 5.02202 8.18291 5.00056 8.15019 4.98589C8.11746 4.97122 8.08216 4.96366 8.04649 4.96368H2.73868C2.71336 4.96368 2.68858 4.97131 2.6674 4.98565C2.64622 4.99999 2.62956 5.02039 2.61947 5.04436C2.60937 5.06834 2.60628 5.09483 2.61058 5.12059C2.61487 5.14635 2.62637 5.17025 2.64364 5.18937L3.76416 6.42872C3.78844 6.45557 3.81779 6.47699 3.85041 6.49166C3.88303 6.50632 3.91822 6.51393 3.95381 6.51399H9.26132C9.28664 6.51399 9.31142 6.50635 9.33261 6.49202C9.35376 6.47768 9.37042 6.45727 9.38056 6.43331C9.39063 6.40933 9.39372 6.38283 9.38942 6.35707C9.38513 6.33132 9.37364 6.30741 9.35638 6.2883L8.2367 5.04894ZM2.73868 4.15871H8.04649C8.08216 4.15872 8.11746 4.15117 8.15019 4.1365C8.18291 4.12183 8.21237 4.10036 8.2367 4.07344L9.35638 2.83409C9.37364 2.81498 9.38513 2.79107 9.38942 2.76531C9.39372 2.73955 9.39063 2.71306 9.38056 2.68908C9.37042 2.66511 9.35376 2.6447 9.33261 2.63037C9.31142 2.61604 9.28664 2.6084 9.26132 2.6084H3.95381C3.91822 2.60846 3.88303 2.61606 3.85041 2.63073C3.81779 2.64539 3.78844 2.66682 3.76416 2.69367L2.64393 3.93302C2.62667 3.95211 2.61518 3.97599 2.61088 4.00172C2.60658 4.02745 2.60964 4.05393 2.6197 4.07789C2.62976 4.10185 2.64638 4.12226 2.66751 4.13661C2.68865 4.15097 2.71338 4.15865 2.73868 4.15871Z",
    fill: "url(#paint0_linear_5041_11410)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5041_11410",
    x1: 3.18123,
    y1: 9.01848,
    x2: 8.94485,
    y2: 2.72327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#9945FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#8752F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#5497D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#43B4CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#28E0B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#19FB9B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5041_11410"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.78261,
    height: 6.26087,
    fill: "white",
    transform: "translate(2.6087 2.6084)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolS);
export default __webpack_public_path__ + "static/media/sol-s.f967b167ea4c18a6fc174d0a16a97bcc.svg";
export { ForwardRef as ReactComponent };